import React from "react";
import "./Common.css";
import ChatWithUs from "@/assets/svgs/faq/ChatWithUs";
import CallWithUs from "@/assets/svgs/faq/CallWithUs";

function NeedSupport(props) {
  return (
    <section className="NeedSupport">
      <h2>Brauchst du weitere Unterstützung?</h2>
      <p>
        Chatte rund um die Uhr mit uns – und wenn du zusätzliche Hilfe
        benötigst, verbinden wir dich während der Geschäftszeiten mit dem
        richtigen Team.
      </p>
      <a
        href="mailto:kundenservice@autoeinfachlos.at"
        className="NeedSupport-button"
      >
        <ChatWithUs />
        <span>Schreibe uns eine E-Mail</span>
      </a>
      <a href="tel:+43720881186" className="NeedSupport-button secondary">
        <CallWithUs />
        <span>Rufe uns an</span>
      </a>
    </section>
  );
}

export default NeedSupport;
